import type { PaddingOptions } from 'mapbox-gl';
import type { ComponentProps, CSSProperties } from 'react';
import useMediaQuery from '@alltrails/core/hooks/useMediaQuery';
import Toast from '@alltrails/denali/components/Toast';
import { BREAKPOINT_MD_SIZE } from '@alltrails/denali/tokens';
import styles from './MapAwareToast.module.scss';

// MapAwareToast will only be rendered at the top of maps (position = "primary")
type MapAwareToastProps = Omit<ComponentProps<typeof Toast>, 'placement' | 'position'> & {
  horizontalMapPadding?: Partial<PaddingOptions>;
};

const MapAwareToast = ({ horizontalMapPadding, ...toastProps }: MapAwareToastProps) => {
  const isMediumDown = useMediaQuery(`(max-width: ${BREAKPOINT_MD_SIZE}px)`);

  const wrapperStyles: CSSProperties = {
    ...(!!horizontalMapPadding?.right && horizontalMapPadding?.right !== null && !isMediumDown && { marginRight: horizontalMapPadding.right }),
    ...(!!horizontalMapPadding?.left && horizontalMapPadding?.left !== null && !isMediumDown && { marginLeft: horizontalMapPadding.left })
  };

  return (
    <div className={styles.mapAwareToastWrapper} style={wrapperStyles} data-testid="toast-wrapper">
      <Toast {...toastProps} placement="inMap" />
    </div>
  );
};

export default MapAwareToast;
